import React, { useState, useEffect } from 'react';
import BusyIndicator from '@concur/nui-widgets/BusyIndicator';
import { withFormatter } from '@concur/nui-intl-runtime';
import { compose, withLogger } from '@concur/core-ui-shell';
import { get as fetchGet } from '../utils/fetchClient';
import { ENDPOINT_URLS } from '../constants';
import InlineError from '../FallbackComponent/_InlineError';
import withLoggerData from '../utils/withLoggerData';

const LastLogin = (props) => {
    const {
        formatter,
        logger,
    } = props;

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [correlationId, setCorrelationId] = useState();
    const [lastLoginContent, setLastLoginContent] = useState();

    const promptLoginHistory = () => {
        const tmpCorrelationId = crypto.randomUUID();
        setIsLoading(true);

        fetchGet(ENDPOINT_URLS.LAST_LOGIN, { headers: { 'concur-correlationid': tmpCorrelationId } })
            .then((response) => {
                setIsLoading(false);
                if (!response.data) {
                    logger.error('Empty last login response', { correlationId: tmpCorrelationId });
                    setError(true);
                    setCorrelationId(tmpCorrelationId);
                } else {
                    setLastLoginContent(response.data);
                }
            }).catch((err) => {
                logger.error(`Fetching last login: ${err.message}`, { correlationId: tmpCorrelationId });
                setIsLoading(false);
                setError(true);
                setCorrelationId(tmpCorrelationId);
            });
    };

    useEffect(() => {
        promptLoginHistory();
    }, []);

    return (
        <>
            {isLoading && (
                <BusyIndicator
                    message={formatter.formattedMessage({ id: 'CoreUI.loading' })}
                    type="fullPage"
                    visible
                    showMessage
                    data-test="busy-indicator"
                />
            )}
            {!isLoading && error && (
                <InlineError correlationId={correlationId} />
            )}
            {!isLoading && !error && (
                // eslint-disable-next-line react/no-danger
                <span data-test="last-login" dangerouslySetInnerHTML={{ __html: lastLoginContent }} />
            )}
        </>
    );
};

LastLogin.displayName = 'LastLogin';

export default compose(
    withLoggerData,
    withLogger,
    withFormatter,
)(LastLogin);
